import { Injectable } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { AppConfig } from './definitions/app-config.interface';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable()
export class ConfigService {
  private _config: AppConfig | null = null;
  private http: HttpClient;

  constructor(handler: HttpBackend) {
    this.http = new HttpClient(handler);
  }

  get configLoaded(): boolean {
    return this._config !== null;
  }

  get config(): AppConfig {
    if (!this._config)
      throw new Error('App configuration not loaded');

    return this._config;
  }

  async loadConfig(): Promise<AppConfig> {
    try {
      const configAsset$ = this.http.get<AppConfig>(environment.appConfigUri);
      const configAsset = await lastValueFrom(configAsset$);

      this._config = configAsset;
      return configAsset;

    } catch (err: any) {
      const status = err?.status;
      const reason = err?.message || 'Unknown error';
      throw new Error(`Failed to load app configuration from '${environment.appConfigUri}'${status ? ` (status ${status})` : ''}: ${reason}`);
    }
  }
}
